import React from 'react';

import AppWrapper from './components/UTMPortal/AppWrapper.js';

export default function UTMPortal() {
  return <AppWrapper />;
}
